import {useEffect, useRef, useState} from 'react';
import useIsMobile from '../../../hook/useIsMobile';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

export default function MobileAppUsage() {

  const stepRef = useRef(0);
  const swiperRef = useRef(null);
  const [step, setStep] = useState(0);

  const isMobile = useIsMobile();

  const data = [
    {
      "index": 1,
      "title": "간편 등록 후 상태 확인",
      "description": "앱에서 링콜을 등록하고\n배터리 잔량과 교체 시기를 확인하세요.",
    },
    {
      "index": 2,
      "title": "신고 진행 상황 실시간 전달",
      "description": "구조 요청부터 조치까지 모든 상황을\n앱에서 확인할 수 있어요.",
    },
    {
      "index": 3,
      "title": "맞춤 · 추천 서비스 제공",
      "description": "생활 정보와 상품 추천을\n앱 메인에서 한눈에 볼 수 있어요.",
    },
    {
      "index": 4,
      "title": "위치 기반 편의시설 안내",
      "description": "현재 위치를 기준으로\n가까운 편의 시설을 쉽게 확인할 수 있어요.",
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      stepRef.current = (stepRef.current + 1) % data.length;
      setStep(prev => (prev + 1) % data.length);

      if (isMobile) swiperRef.current?.slideTo(stepRef.current)
    }, 3000);

    return () => {
      clearInterval(interval);
    }
  }, []);

  return (
    <section className='top-space bg-[#FAFAFA] py-[80px] lg:py-[180px]'>
      {
        isMobile 
        ?
        <div className='wrapper'>
          <Swiper
            ref={swiperRef}
            onSwiper={(swiper) => swiperRef.current = swiper}
            onSlideChange={swiper => setStep(swiper.activeIndex)}
            loop={true}
            spaceBetween={80}
            grabCursor={true}
            pagination={true}
            slidesPerView={1}
            className='p-[60px]'
            modules={[Pagination]}
            style={{
              "--swiper-pagination-color": "#ff692e",
            }}
          >
            {
              Array.from({ length: 4 }, (_, i) => (
                <SwiperSlide >
                  <img 
                      key={i}
                      src={`${process.env.REACT_APP_STATIC_URL}/images/main/linkcall_mobile${i + 1}.png`}
                      className='w-[300px] mx-auto aspect-[193/430] rounded-[18px] border-[5px] border-white'
                      style={{ boxShadow: '2px 7px 23px 0px rgba(0, 0, 0, 0.10)' }}
                    />
                </SwiperSlide>
              ))
            }
          </Swiper>
            
          <div className='mt-[24px] text-center text-heading1 font-bold'>
            {data[step].title}
          </div> 
          <div className='mt-[8px] whitespace-pre-line text-label-100 text-body1 font-medium text-center'>
            {data[step].description}
          </div>

        </div>
        :
        <div className='wrapper gap-[120px] flex flex-col lg:flex-row justify-center items-center transition-all duration-200 ease-in-out'>
          <div 
              className="w-full lg:w-[30%] aspect-[282/610] px-[10px] flex items-center rounded-[30px] bg-white"
              style={{ boxShadow: '5.841px 9.734px 33.097px 0px rgba(0, 0, 0, 0.08)' }}
          >
            <img
              className=' rounded-[20px] object-cover object-center' 
              src={`${process.env.REACT_APP_STATIC_URL}/images/main/linkcall_mobile${step + 1}.png`}
            />
          </div> 

          <div className='h-[640px] flex flex-col justify-between'>
            {
              data.map(item => (
                <div
                  key={item.index}
                  onClick={() => setStep(item.index - 1)}
                  className={`cursor-pointer select-none transition-opacity ease-in-out duration-700 ${step + 1 !== item.index && 'opacity-25'}`}
                >
                  <div className='text-title2 font-bold'>{item.title}</div>
                  <div className='text-label-100 mt-[20px] whitespace-pre-line text-heading2 '>{item.description}</div>
                </div>
              ))
            }
          </div>
        </div>
      }
    </section>
  )
}